import { createExperimentHook } from '@prisjakt/ui-experiment';
import { SortOptionEnum } from 'src/components/price-list/types';

export const useAlternativeFacetNavigation = createExperimentHook(
  'alternative-facet-navigation',
  false,
  {
    useAlternativeFacetNavigation: true,
  }
);

export const useChangelogPositionExperiment = createExperimentHook(
  'changelog-position',
  true,
  { alternate: false }
);

export type SearchResultLayoutExperimentType =
  | boolean
  | 'wide'
  | 'without panorama'
  | 'wide and without panorama';

export const useSearchResultLayoutExperiment = createExperimentHook<
  SearchResultLayoutExperimentType
>('search-result-layout', false, {
  wide: 'wide',
  withoutPanorama: 'without panorama',
  wideAndWithoutPanorama: 'wide and without panorama',
});

export type TrailingSkyscraperExperimentType =
  | boolean
  | 'trailing skyscraper'
  | 'trailing and refreshing skyscraper';

export const useTrailingSkyscraperExperiment = createExperimentHook<
  TrailingSkyscraperExperimentType
>('trailing-skyscraper', false, {
  trailingSkyscraper: 'trailing skyscraper',
  trailingAndRefreshingSkyscraper: 'trailing and refreshing skyscraper',
});

export type NewStandardDeliveryTimeType =
  | false
  | 'without-label'
  | 'shipping-label'
  | 'delivery-label';

export const useNewStandardDeliveryTime = createExperimentHook<
  NewStandardDeliveryTimeType
>('new-standard-delivery-time', false, {
  withoutLabel: 'without-label',
  shippingLabel: 'shipping-label',
  deliveryLabel: 'delivery-label',
});

export const useSortByFeaturedExperiment = createExperimentHook(
  'sortby-featured',
  false,
  {
    sortByFeatured: true,
  }
);

export type DefaultOfferlistSortinExperimentType = boolean | SortOptionEnum;

export const useDefaultOfferlistSortinExperiment = createExperimentHook<
  DefaultOfferlistSortinExperimentType
>('default-sorting', false, {
  lowestPriceInStock: SortOptionEnum.PRICEANDSTOCKSTATUS,
  recommended: SortOptionEnum.RECOMMENDED,
});

export const useNewSearchApiKWLP = createExperimentHook(
  'new-search-index-kwlp',
  false,
  {
    new: true,
  }
);

export const useProductPageNavExperiment = createExperimentHook(
  'product-page-nav',
  false,
  {
    new: true,
  }
);
